<template>
  <div class="man band-card">
    <div class="nav">
      <Nav :title="navTitle" :fixed="false"></Nav>
      <div class="top"></div>
    </div>
    <van-form validate-first @submit="submit">
      <van-field
        required
        disabled
        v-model="form.PatientName"
        size="large"
        label="姓名"
        :rules="[
          { 
            required: true, 
          },
        ]"
      />
      <van-field
        required
        disabled
        v-model="form.IDCardNo"
        size="large"
        label="身份证号码"
        :rules="[
          { 
            required: true, 
          },
        ]"
      />
      
      <van-field
        required
        v-model="form.Address"
        size="large"
        label="现住址"
        placeholder="请输入现住址"
        :rules="[
          { 
            required: true, 
            message: '请输入地址' ,
          },
        ]"
      />
      <van-field
        v-model="form.Mobile"
        required
        size="large"
        label="手机号码"
        placeholder="请输入手机号码"
        :rules="[
          {
            required: true,
            message: '手机号码格式不正确',
            validator: certificatePhone,
          },
        ]"
      />
      <van-field
        required
        disabled
        v-model="form.PatientAge"
        size="large"
        label="年纪"
        :rules="[
          { 
            required: true, 
          },
        ]"
      />
      <van-field
        required
        disabled
        v-model="form.PatientSex"
        size="large"
        label="性别"
        :rules="[
          { 
            required: true, 
          },
        ]"
      />
      <van-field
        required
        disabled
        v-model="form.BirthDay"
        size="large"
        label="生日"
        :rules="[
          { 
            required: true, 
          },
        ]"
      />
      <div class="submit" v-if="ishaveID">
        <van-button
          class="bottom_button"
          round
          block
          type="info"
          native-type="submit"
          size="nomal"
          >建档并绑定</van-button
        >
      </div>
    </van-form>
    <div class="empty"></div>
  </div>
</template>

<script>
import setOptions from "@/mixins/setOption";
import Nav from "@/components/nav.vue";
import area from "../../../utils/area1.js";
export default {
  mixins: [setOptions],
  data() {
    return {
      navTitle: "修改信息",
      ispath:null,
      ishaveID: true,
      area: area,
      form: {
        CardNo:"",
        PatientID:"",
        PatientAge: "",
        PatientName: "",
        PatientSexID: "",
        PatientSex:"",
        IDCardNo: "",
        BirthDay: "",
        Address: "",
        Mobile: "",
      },
    };
  },
  components: {
    Nav,
  },
  mounted() {
    // this.getcoulms();
    if(this.$route.query.ispath){
      this.ispath=this.$route.query.ispath
    }

    this.getBindFormData();
    // this.getIdInformation();
  },
  created() {},
  methods: {
    async getIdInformation() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/medicalcard/UpdateCardInfo";
        let data = null;
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            console.log(data,"零售用户返回的信息")
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    //根据身份证获取年龄
    getage(idcard) {
      let myDate = new Date();
      let month = myDate.getMonth() + 1;
      let day = myDate.getDate();
      let PatientAge = myDate.getFullYear() - idcard.substring(6, 10) - 1;
      if (
        idcard.substring(10, 12) < month ||
        (idcard.substring(10, 12) == month &&
          idcard.substring(12, 14) <= day)
      ) {
        PatientAge++;
      }
      return PatientAge.toString();
    },
    //nav返回
    onClickLeft() {
      this.$router.go(-1);
    },
    getBindFormData() {
      if (
        this.$route.query.clientName ||
        this.$route.query.certificateNo
      ) {
        this.form.PatientID = this.$route.query.PatientID;
        this.form.PatientSex = this.$route.query.PatientSex
        this.form.CardNo = this.$route.query.CardNo;
        this.form.PatientName = this.$route.query.clientName;
        this.form.PatientAge = this.getage(this.$route.query.certificateNo)
        this.form.IDCardNo = this.$route.query.certificateNo;
        this.form.PatientSexID = this.getgenderIDbyIdCard(
          this.$route.query.certificateNo
        );
        this.form.BirthDay = this.getBirthdayFromIdCard(
          this.$route.query.certificateNo
        );
      }
    },
    //通过身份证号获得性别
    getgenderIDbyIdCard(idcard) {
      if (parseInt(idcard.substr(16, 1)) % 2 == 1) {
        //男
        return "1";
      } else {
        //女
        return "2";
      }
    },
    //通过身份证获取生日
    getBirthdayFromIdCard(idCard) {
      var BirthDay = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 18) {
          BirthDay = idCard.substr(6, 8);
        }

        BirthDay = BirthDay.replace(/(.{4})(.{2})/, "$1-$2-");
      }

      return BirthDay;
    },
    //根据对象value拿name
    findValueByname(value, info) {
      // for (let temp in info) {
      //   if (info[temp].value == value) {
      //     return info[temp].name;
      //   }
      // }
      return info.find((info) => info.value === value).name;
    },
    // 根据KEY拿VALUE
    findkeyByvalue(key, info) {
      return info.find((info) => info.key === key).value;
    },
    //获取地址
    getaddres(idnum) {},

    // 证件号码校验
    certificateNoValidator(value) {
      if (this.form.certificateType === "1")
        return /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/.test(value);
      return true;
    },
    //手机号验证
    certificatePhone(value) {
      return /^1(3|4|5|6|7|8|9)\d{9}$/.test(value);
    },
    // 提交表单
    async submit() {
        console.log(this.form)
      try {
        this.$showLoad();
        //注册
        let url = "/medicalcard/UpdateCardInfo";
        let data = {
          CardNo: this.form.CardNo,
          Birthday: this.form.BirthDay,
          PatientName: this.form.PatientName,
          PatientAge: this.form.PatientAge,
          IDCardNo: this.form.IDCardNo,
          Address: this.form.Address,
          Mobile: this.form.Mobile,
          PatientID: this.form.PatientID,
          PatientSexID: this.form.PatientSexID,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            if(data.data==400){
              this.$toast.fail('绑卡失败，请稍后重试')
              return
            };
              if(this.ispath==1){
                this.$toast.success("注册并绑定成功");
              setTimeout(() => {
                this.$router.push('/patient_card_selectuser_querydept');
              }, 1000);
              return
              }
              if (data.status === 200) {
                this.$toast.success("注册并绑定成功");
                setTimeout(() => {
                  this.$router.push('/patient_card_list_D');
                }, 1000);
              } else {
                this.$toast.fail("网络连接失败，请稍后重试");
              }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.$toast.fail("注册并绑定失败, 请核对信息重试");
      }
    },
    //格式化日期
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100vw;
  margin-bottom: 15px;
  .top {
    height: 50px;
  }
}
</style>
<style lang="scss">
.band-card {
  .van-cell {
    font-size: 16px;
  }
  .van-cell.van-cell--large {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .van-field__error-message {
    font-size: 14px;
  }
}
.van-field--disabled .van-field__label {
  color: #646566;
}
// 建档按钮
.submit {
  margin: 0px 0px;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 70px;
  display: flex;
  justify-items: center;
  align-items: center;
  background-color: #ffffff;
  border-top: 1px solid #aaaaaa;
  .bottom_button {
    width: 90%;
    margin: 0px auto;
  }
}
.empty {
  height: 65px;
}
</style>